// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimPage-cls1_I1N","cls2":"ClaimPage-cls2_BCo ClaimPage-cls1_I1N"};